const COVERAGE_IMG =
  "https://images.unsplash.com/photo-1771957307760-3ebd89a19606?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxldXJvcGVhbiUyMGhpZ2h3YXklMjBkcml2aW5nJTIwbmlnaHR8ZW58MHx8fHwxNzgwOTk4NDU2fDA&ixlib=rb-4.1.0&q=85";

const REGIONS = [
  "Midlands",
  "London",
  "Manchester",
  "Birmingham",
  "Scotland",
  "South Coast",
  "Wales",
  "Northern Ireland",
  "France",
  "Germany",
  "Belgium",
  "Netherlands",
  "Italy",
  "Spain",
  "Switzerland",
  "Austria",
];

export default function Coverage() {
  return (
    <section
      id="coverage"
      data-testid="coverage-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-6">
            <span className="w-8 h-px bg-[#E60000]" />
            Coverage · 04
          </div>
          <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.0]">
            Burton based.
            <br />
            <span className="text-zinc-500">UK + Europe</span>
            <br />
            covered.
          </h2>
          <p className="mt-6 text-zinc-400 text-base lg:text-lg leading-relaxed max-w-md">
            Operating out of Burton Upon Trent at the heart of the Midlands —
            within easy reach of the M1, M6 and M42. From Cornwall to the
            Highlands, Calais to Como, we plan the route and handle the
            paperwork.
          </p>

          <div className="mt-10 flex flex-wrap gap-2">
            {REGIONS.map((r) => (
              <span
                key={r}
                className="text-xs tracking-wider uppercase text-zinc-300 border border-white/10 px-4 py-2 hover:border-[#E60000] hover:text-white transition-colors"
                data-testid={`region-chip-${r.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {r}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2 relative">
          <div className="relative aspect-[4/5] sm:aspect-[16/10] w-full overflow-hidden border border-white/10">
            <img
              src={COVERAGE_IMG}
              alt="European highway at night with light trails"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-10 flex items-end justify-between gap-6">
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold">
                  Operating since
                </div>
                <div className="font-display text-white text-5xl lg:text-7xl font-extrabold mt-2">
                  2025
                </div>
              </div>
              <div className="text-right">
                <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-400 font-bold">
                  Vehicles moved
                </div>
                <div className="font-display text-white text-3xl lg:text-5xl font-extrabold mt-2">
                  1,200+
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
